<template>
    <div>
        <div class="content">

            <b-container fluid class="mt-4">

                <stats-card title="Roles &amp; Permissions" type="default" sub-title="Create Role" icon="fas fa-shield">

                    <template slot="append">

                        <b-card no-bod class="tab-wrapper">


                            <div class="tab-container" v-if="availablePermissions">

                                <base-alert>
                                    Select an existing role as a base:
                                </base-alert>

                                <b-form-select v-on:change="onViewEditPermissions" v-if="addRoleOptions.length > 0" v-model="expandedRole" :options="addRoleOptions"></b-form-select>

                                <div v-if="expandedRole">

                                    <hr>

                                    <card class="no-border-card" body-classes="" footer-classes="">

                                        <div >

                                            <b-col cols="12" class="d-flex justify-content-between flex-wrap align-items-center">
                                                <div>
                                                    <base-input v-on:input="filterPermissions" v-model="permissionsFilter"  placeholder="Filter permissions"> </base-input>
                                                </div>
                                                <div>
                                                    <base-switch onText="All" offText="None"  v-on:input="onPermissionsToggle"></base-switch>
                                                </div>
                                            </b-col>

                                            <el-table
                                                class="table-responsive table-flush"
                                                header-row-class-name="thead-light"
                                                row-key="id"
                                                :data="filteredPermissions"
                                                >
                                                <el-table-column label="Permission" prop="description" sortable>
                                                    <template v-slot="{ row }">
                                                        <b>{{ row.description }}</b>
                                                    </template>
                                                </el-table-column>

                                                <el-table-column label="System name" prop="permission" sortable>
                                                    <template v-slot="{ row }">
                                                        <pre>{{ row.permission }}</pre>
                                                    </template>
                                                </el-table-column>

                                                <el-table-column label="Granted" prop="active" sortable align="center">
                                                    <template v-slot="{ row }">
                                                        <!-- <div class="d-flex"> -->
                                                            <base-switch v-on:input="onPermissionToggle(row.permission)" v-model="permissionsMatrix[expandedRole][row.permission]"></base-switch>
                                                        <!-- </div> -->
                                                    </template>
                                                </el-table-column>
                                            </el-table>

                                        </div>
                                    </card>
                                </div>

                                <b-row align-v="center" align-h="between" class="" v-if="expandedRole != null">
                                    <b-col cols="12" align="right">
                                        <base-button type="success" @click="showConfirmPermissionsChanges">
                                            Create Role / Permissions set
                                        </base-button>
                                    </b-col>
                                </b-row>

                            </div>
                        </b-card>
                    </template>
                </stats-card>
            </b-container>
        </div>

        <!-- MODALS -->

        <modal :show.sync="showConfirmChanges">
            <h6 slot="header" class="modal-title">One last thing</h6>

            <!-- <base-alert>
                Give your permissions set a role name:
            </base-alert> -->

            <base-input label="Name" v-model="newRole.name" placeholder=""></base-input>
            <base-input label="Description" v-model="newRole.description" placeholder=""></base-input>

            <template slot="footer">
                <base-button type="blank" @click="showConfirmChanges = false">Cancel</base-button>
                <base-button type="success" @click="savePermissionSet" :disabled="newRole.name == ''">Create role</base-button>
            </template>
        </modal>


        <!-- END MODALS -->
    </div>
</template>

<script>

import api from '@/api'
import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown, Tooltip } from 'element-ui';
import { RoleModel } from '@/models/access/role'

export default {
  components: {
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu
  },
  data() {
    return {
        userData: null,
        availableRoles: null,
        availablePermissions: null,
        filteredPermissions: null,
        expandedRole: null,
        permissionsMatrix: {},
        permissionsFilter: '',
        showConfirmChanges: false,
        showConfirmDelete: false,
        hasNoPermissions: false,
        showAddRole: false,
        addRoleSelected: null,
        addRoleOptions: [],
        activeTab: 0,
        newRole: new RoleModel()
    };
  },
  created: async function() {
    this.$emit('loading', true);
    await this.fetchAvailablePermissions();
    this.$emit('loading', false);
  },
  methods: {
    savePermissionSet: async function() {
        this.newRole.allows = []
        for(let x in this.permissionsMatrix[this.expandedRole]) {
            if(this.permissionsMatrix[this.expandedRole][x]) {
                this.newRole.allows.push(x)
            }
        }

        this.$emit('loading', true);
        const response = await api.createRole(this.newRole.exportToCreate());

        this.$emit('loading', false);
        if (response) {
          this.$emit('onApiResult', 'Role created');
          this.showConfirmChanges = false;
          this.$router.push('/access/roles');
        }
    },
    showConfirmPermissionsChanges: function() {
        this.showConfirmChanges = true;
    },
    filterPermissions: function(label) {
        let allPermissions = this.availablePermissions
        if(label.length > 2) {
            this.filteredPermissions = allPermissions.filter((p) => p.description.toLowerCase().indexOf(label.toLowerCase()) != -1 || p.permission.indexOf(label.toLowerCase()) != -1);
        }
        else {
            this.filteredPermissions = allPermissions;
        }
    },
    onPermissionToggle: function(name) {
    },
    onPermissionsToggle: function(all) {
        const role = this.expandedRole;
        this.expandedRole = null;
        for(let p in this.availablePermissions) {
            this.permissionsMatrix[role][this.availablePermissions[p].permission] = all;
        }
        this.expandedRole = role;
    },
    getAvailablePermissions: async function() {
        this.$emit('loading', true);
        const results = await api.getRoles()
        // const dis = this;
        this.addRoleOptions = results.roles.map(function(r) {
            return {
                value: r.name,
                text: `${r.name} - ${r.description}`,
            }
        })
        this.addRoleOptions.unshift({
            value: null,
            text: "Select..."
        })

        this.availableRoles = results.roles;

        const p = await api.getPermissions()

        this.$emit('loading', false);

        this.availablePermissions = p.permissions;
        this.filteredPermissions = p.permissions;
    },
    // hasUserRole: function(role) {
    //     return this.userData.permissions.filter((p) => p.role == role).length > 0;
    // },
    fetchAvailablePermissions: async function() {
        if(!this.availablePermissions) {
            await this.getAvailablePermissions();
        }
    },
    hasPermission: function(name, role) {
        return this.availableRoles.filter((p) => p.name == role)[0].allows.filter((a) => a == name).length > 0;
    },
    onViewEditPermissions: async function(role) {
        this.expandedRole = null;
        this.permissionsMatrix[role] = {};
        for(let p in this.availablePermissions) {
            this.permissionsMatrix[role][this.availablePermissions[p].permission] = this.hasPermission(this.availablePermissions[p].permission, role);
        }
        this.expandedRole = role;
    }
  }
};
</script>
